// ТРЕТИЙ ШАГ В КОРЗИНЕ - ОПЛАТА

function cartPayment() {

  $('.js-payment-user_type').on('change',function(){
    $('.js-status-payment').slideToggle();
    $('.js-form-order__np').text($(this).siblings('div').text());
    $('.js-radiobutton_status').removeClass('radiobutton_status--active');
    $(this).parent().addClass('radiobutton_status--active');
    var inf = {
      user_type : $(this).data('user_type')
    }
    $.ajax({
      method: "POST",
      url: '/oa/Select_UserType/',
      data: inf,
      dataType:'json'
    }).then((data) => {
      console.log(data);
    });
  })
  $('.js-basket-info__input, .js-payment textarea').on('change',function() {
      var input = new FormData(document.getElementById('form_payment'));
      $.ajax({
        method: "POST",
        url: '/oa/User_Info/',
        data: input,
        processData: false,
        contentType: false,
        dataType:'json'
      }).then((data) => {
        console.log(data);
      })
    })
    $('.js-payment-choice').on('change',function(){
      $('.delivery-choice__item').removeClass('delivery-choice__item_active');
      $(this).parents('.delivery-choice__item').addClass('delivery-choice__item_active');
      $('.js-form-order__payment-method').text($(this).siblings('.js-radiobutton__text').text());
      $('.js-delivery-choice__item .js-radiobutton__descr').css('display','none');
      $(this).parents('label').siblings('.js-radiobutton__descr').slideToggle();
      var inf = {
        payment_id: $(this).data('payment_id'),
      }
      $.ajax({
        method: "POST",
        url: "/oa/Select_Payment/",
        data: inf
      }).then((data) => {
        console.log(data);
      })
    })
    $('.js-form-formorder__btn').click(function(e){
  	  var btn_data = $(this).data();
      e.preventDefault();
  	  $('.js-form-formorder__btn').prop('disabled', true).addClass('m--loader');
  	  $('.js-form-formorder__alert').hide();
  	  $('.js-basket-info__input').removeAttr('style');
      var input = new FormData(document.getElementById('form_payment'));
      $.ajax({
        method: "POST",
        url: '/oa/Order_Submit/',
        data: input,
        processData: false,
        contentType: false,
        dataType:'json'
      }).then((data) => {
	  	  $('.js-form-formorder__btn').prop('disabled', false).removeClass('m--loader');
        if (data.errors) {
          for (var i = 0; i < data.errors.length; i++) {
            $('input[name="'+data.errors[i]+'"]').css('border-bottom-color','FireBrick');
            $('input[name="'+data.errors[i]+'"]').css('background','rgba(139,0,0,.2)');
          }
		      $('.js-form-formorder__alert').show();
        } else {
          let products = [];
          data.data.items.forEach((item) => {
            products.push({
              id: item.modif_id,
              name: item.modif_name,
              price: item.price,
              brand: 'Carforma',
              //category: 'Авто',
              quantity: item.count,
              list: 'Результаты поиска',
              //position: item.position
            });
          });
		  if (window.dataLayer) {
	          window.dataLayer.push({
	            ecommerce: {
	              currencyCode: 'RUB',
	              purchase: {
	                actionField: {
	                  id: data.data.order_id
	                },
	                products: products
	              }
	            }
	          });
		  }
          $('.js-order__block').html(data.content);
		      $("html, body").animate({
		        scrollTop: 0
		      }, 1000);
		      //ym(64417021, 'reachGoal', 'order_step_3');
          $(window).trigger('goal.main', btn_data);
        }
      }).catch(err => {
        $('.js-form-formorder__btn').prop('disabled', false).removeClass('m--loader');
        alert('Ошибка отправки заказа! Повторите попытку позже!');
        console.log(err)
      });
    })
    var blocker = 0;
    $('.js-payment-choice').each(function(){
      if ($(this).prop('checked')) {
        blocker = 1;
      }
    })
    if ($('.js-agreement-checkbox .js-basket-info__input').prop('checked') && blocker) {
      $('.js-form-formorder__btn').prop('disabled', false);
    } else {
      $('.js-form-formorder__btn').prop('disabled', true);
    }
    $('.js-payment-choice, .js-agreement-checkbox .js-basket-info__input').on('change',function(){
    var blocker = 0;
    $('.js-payment-choice').each(function(){
      if ($(this).prop('checked')) {
        blocker = 1;
      }
    })
    if ($('.js-agreement-checkbox .js-basket-info__input').prop('checked') && blocker) {
      $('.js-form-formorder__btn').prop('disabled', false);
    } else {
      $('.js-form-formorder__btn').prop('disabled', true);
    }
  })
}

export {
  cartPayment
};
